<div class="topbar shadow">
  <div class="topbar-menu d-flex align-items-center gap-1">
    <div class="logo-box">
      <a href="index.html" class="logo-light">
        <img [src]="logo" alt="logo" class="logo-lg">
        <img src="assets/images/logo-sm.png" alt="small logo" class="logo-sm">
      </a>
    </div>
  </div>

  <ul class="topbar-menu d-flex align-items-center">
    <li class="d-none d-md-inline-block">
      <a class="nav-link waves-effect waves-light" href="" data-toggle="fullscreen">
        <i class="fe-maximize font-22"></i>
      </a>
    </li>

    <!-- User Dropdown -->
    <li class="nav-item dropdown u-pro" clickOutside (clickOutside)="closeDropdown()">
      <a class="nav-link dropdown-toggle nav-user me-0 waves-effect waves-light" href="javascript:;"
        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [class.show]="isMenuOpen"
        (click)="isMenuOpen = !isMenuOpen">
        <div>
          <img [src]="user.imageUrl" imageLoad alt="user-image" class="rounded-circle">
          <span class="ms-1 d-none d-md-inline-block">
            {{user.fname + ' '+ (user.lname || '')}} <i class="mdi mdi-chevron-down"></i>
          </span>
        </div>
        <p>{{user.role?.[0]?.roleName}}</p>
      </a>
    </li>

    <!-- Right Bar offcanvas button (Theme Customization Panel) -->
    <li>
      <a class="nav-link waves-effect waves-light" data-bs-toggle="offcanvas" href="#theme-settings-offcanvas">
        <i class="fe-settings font-22"></i>
      </a>
    </li>
    <div [class.show]="isMenuOpen" (click)="closeDropdown()"
      class="dropdown-menu dropdown-menu-profile dropdown-menu-right animated flipInY m-t-5">
      <!-- item-->
      <div class="dropdown-header noti-title">
        <b class="text-overflow m-0">Welcome !</b>
      </div>

      <!-- item-->
      <a href="javascript:void(0);" class="dropdown-item notify-item" [routerLink]=" [UrlService.USER_PROFILE_ROUTE]">
        <i class="pi pi-user me-2"></i>
        <span>My Account</span>
      </a>

      <!-- item-->

      <a (click)="openChangePassword()" class="dropdown-item notify-item"><i class="icon-lock"></i> Change
        Password</a>

      <div class="dropdown-divider"></div>

      <!-- item-->
      <a (click)="logout()" href="javascript:void(0);" class="dropdown-item notify-item">
        <i class="pi pi-sign-out me-2"></i>
        <span>Logout</span>
      </a>

    </div>
  </ul>

</div>